import React, { Fragment } from "react";
import { Link as RouterLink } from "react-router-dom";

import Breadcrumbs from "@material-ui/core/Breadcrumbs";
import Container from "@material-ui/core/Container";
import Link from "@material-ui/core/Link";
import { makeStyles } from "@material-ui/core/styles";

import NavigateNextIcon from "@material-ui/icons/NavigateNext";

const useStyles = makeStyles((theme) => ({
  breadcrumb: {
    justifyContent: "center",
    flexWrap: "wrap",
    paddingLeft: "0px",
  },
}));

export default function AdmAreaBreadcrumbs({ admDetails, color }) {
  const classes = useStyles();
  return (
    <Fragment>
      {!!admDetails && (
        <Container className={classes.breadcrumb}>
          <Breadcrumbs
            separator={<NavigateNextIcon fontSize="small" />}
            aria-label="breadcrumb-adm"
          >
            {!!admDetails.country && (
              <Link
                color={!!color ? color : "textSecondary"}
                variant="caption"
                component={RouterLink}
                to={`/adm-areas/${admDetails.country.admId}`}
                underline="none"
              >
                {admDetails.country.name}
              </Link>
            )}
            {!!admDetails.adm1 && (
              <Link
                color={!!color ? color : "textSecondary"}
                variant="caption"
                component={RouterLink}
                to={`/adm-areas/${admDetails.adm1.admId}`}
                underline="none"
              >
                {admDetails.adm1.name}
              </Link>
            )}
            {!!admDetails.adm2 && (
              <Link
                color={!!color ? color : "textSecondary"}
                variant="caption"
                component={RouterLink}
                to={`/adm-areas/${admDetails.adm2.admId}`}
                underline="none"
              >
                {admDetails.adm2.name}
              </Link>
            )}
          </Breadcrumbs>
        </Container>
      )}
    </Fragment>
  );
}
